import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { getAdminDetails } from "../../redux/actions/campaignActions";
import ImgChangeIcon from "../../assets/images/camera-icon.png";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Loader from "../../components/Loader/Loader";
import "./new.scss";

const New = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const adminView = useSelector((state) => state.adminView);
  const { adminDetails } = adminView;
  // const adminLogin = useSelector((state) => state.adminLogin);
  // const { user } = adminLogin;

  let token = localStorage.getItem("accessToken");
  const id = JSON.parse(localStorage.getItem("admin")).data.id;

  // useEffect(() => {
  //   if (user) {
  //     setUserId(user?.data?.id);
  //   }
  // }, [user]);

  useEffect(() => {
    if (adminView) {
      if (adminView?.loading !== undefined) {
        setLoading(adminView?.loading);
      }
    }
  }, [adminView]);

  useEffect(() => {
    dispatch(getAdminDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (adminDetails?.data?.profilePic !== null) {
      setFile({
        files: "",
        preview: adminDetails?.data?.profilePic,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [adminDetails]);

  useEffect(() => {
    if (adminDetails) {
      setValue("firstname", adminDetails?.data?.firstname);
      setValue("lastname", adminDetails?.data?.lastname);
      setValue("email", adminDetails?.data?.email);
      setValue("phone", adminDetails?.data?.mobile);
      setValue("marital_status", adminDetails?.data?.marital_status);
      setValue("gender", adminDetails?.data?.gender);
      setProfile_pic_name(adminDetails?.data?.profilePic);
    }
  }, [adminDetails]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = async (e) => {
    const baseUrl = process.env.REACT_APP_API + "admin/update-userprofilepic";
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let formData = new FormData();
      setLoading(true);
      formData.append("user_id", id);
      formData.append("file", selected);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      };
      const res = await axios
        .patch(baseUrl, formData, axiosConfig)
        .then((response) => {
          // console.log("res",response);
          setFile({
            files: response?.data?.data?.document_name,
            preview: response?.data?.data?.document_name,
          });
          setError(false);
          setLoading(false);
        });
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("id", id);
    // formData.append("file", file?.files);
    if (file.files !== "" && adminDetails.data.profilePic == "") {
      formData.append("profile_pic", file?.files);
    } else if (file.files !== "" && adminDetails.data.profilePic !== "") {
      formData.append("profile_pic", file?.files);
      formData.append("profile_pic_name", adminDetails.data.profilePic);
    }

    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "admin/update-user-details",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit Profile</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : adminDetails?.data?.profilePic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z._ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  {...register("phone", {
                    required: "Phone is required",
                  })}
                  placeholder="Enter Phone"
                />
                {errors.phone && (
                  <div className="invalid-feedback">{errors.phone.message}</div>
                )}
              </div>

              <div className="formInput">
                <label>Marital Status</label>
                {/* <input
                  type="text"
                  name="marital_status"
                  {...register("marital_status")}
                  placeholder="Enter Marital Status"
                /> */}
                <select
                  name="marital_status"
                 
                  {...register("marital_status", {
                    required: "This field is required",
                  })}
                >

                  <option value="Married">Married</option>
                  <option value="Single">Single</option>
                  <option value="Divorce">Divorce</option>

                </select>
                {errors.marital_status && (
                  <div className="invalid-feedback">
                    {errors.marital_status.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Gender</label>
                {/* <input
                  type="text"
                  name="gender"
                  {...register("gender", {
                    required: "Gender is required",
                  })}
                  placeholder="Enter Gender"
                /> */}
                <select
                  name="gender"
                  
                  {...register("gender", {
                    required: "This field is required",
                  })}
                >

                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  

                </select>
                {errors.gender && (
                  <div className="invalid-feedback">
                    {errors.gender.message}
                  </div>
                )}
              </div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
